import React from 'react';
import PropTypes from 'prop-types';

import {
  gray900, primary, secondary, tertiary, tertiary400,
} from 'components/new_ui/Colors';

export default function Icon({ variant }) {
  let color = primary;

  switch (variant) {
    case 'secondary':
      color = secondary;
      break;

    case 'tertiary-1000':
      color = tertiary;
      break;

    case 'tertiary-400':
      color = tertiary400;
      break;

    default:
      color = primary;
  }

  /* eslint-disable max-len */
  return (
    <svg width="50" height="50" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M54.2498 13.1957C54.2498 17.3218 50.7801 20.6667 46.4999 20.6667C42.2197 20.6667 38.75 17.3218 38.75 13.1957C38.75 9.06952 38.75 5.16682 38.75 5.16682L54.25 5.16675C54.25 5.16675 54.2498 10.7498 54.2498 13.1957Z" fill={color} />
      <path fillRule="evenodd" clipRule="evenodd" d="M35.5211 7.75H5.17861L5.16663 18.0833L18.0767 18.0832L18.0707 56.8332H28.404L28.404 18.0832L36.6974 18.0832C35.945 16.6496 35.5211 15.0284 35.5211 13.3119L35.5211 7.75ZM46.4998 23.8956C48.3677 23.8956 50.1267 23.4459 51.6666 22.6526V56.8333H41.3333V22.6528C42.8731 23.4459 44.632 23.8956 46.4998 23.8956Z" fill={gray900} />
    </svg>
  );
  /* eslint-enable max-len */
}

Icon.propTypes = {
  variant: PropTypes.string.isRequired,
};
